import React, { Component } from 'react'
import _ from 'lodash'
import Config from './configs'
import * as API from './api'

import Page from './components/Page'
import EmptyPage from './components/EmptyPage'
import CounterPage from './components/CounterPage'
import ProvisionPage from './components/ProvisionPage'

import './css/App.css';

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      trackingNumbers: []
    }
    this.intervalTimer = null
    this.errorCount = 0
    this.errorStatus = 0
  }

  componentDidMount() {
    if (API.hasCredential()) {
      this._startFetchData()
    }
  }
  componentWillUnmount() {
    clearInterval(this.intervalTimer)
  }

  render() {
    const { trackingNumbers, errorStatus } = this.state

    if (errorStatus === 401 || !API.hasCredential()) return this._renderProvision()
    if (_.isEmpty(trackingNumbers)) return this._renderEmpty()

    return (
      <Page>
        <CounterPage trackingNumbers={trackingNumbers} />
      </Page>
    );
  }

  _renderEmpty = () => {
    return <Page><EmptyPage /></Page>
  }

  _renderProvision = () => {
    return <ProvisionPage onNext={() => {
      this.setState({
        errorStatus: 0
      }, () => this._startFetchData())
    }} />
  }

  _fetchDataFromAPI = () => {
    if (this.errorCount < Config.get('MAXIMUM_ERRORS_RETRY')) {

      API.getShipments()
        .then((response)=> {
          const fake_numbers = _.toInteger(Config.get('FAKE_TICKET_NUMBERS'))
          if (fake_numbers > 0 && Config.get('ALLOW_FAKE_TICKET_NUMBERS')) {
            response = {
              'status': 'success',
              'code': 0,
              'data': {
                'shipments': _.range(fake_numbers).map((n,i) => ({
                  'id': fake_numbers-i,
                  'created_at': "2018-03-22T17:0929.435+08:00",
                  'updated_at': "2018-03-22T17:0929.435+08:00",
                  'ticket_number': 100+(fake_numbers-i),
                }))
              }
            }
          }
          this.setState({
            trackingNumbers: this._getTrackingNumbers(response)
          })

        })
        .catch((error)=> {
          this.setState(() => {
            if (error.code ===  401) {
              clearInterval(this.intervalTimer)
            }
            this.errorCount++
            return {errorStatus: error.code}
          })
        })
    }
    else {
      clearInterval(this.intervalTimer)
      window.location.reload() // refresh browser if max errors retry reached.
    }

  }

  _getTrackingNumbers = (response) => {
    const trackingNumbers = [];
    if (!_.isEmpty(response.data.shipments)) {
      _.map(response.data.shipments, (shipment, index)=>{
        trackingNumbers.push(_.pick(shipment, ['ticket_number']))
      })
    }
    // Only Show first 31 numbers on the display
    return trackingNumbers.length > 31 ? _.slice(trackingNumbers, 0, 31) : trackingNumbers;
  }

  _startFetchData = () => {
    const fetchInterval = Config.get('FETCH_INTERVAL')
    this.intervalTimer = setInterval( this._fetchDataFromAPI, fetchInterval)
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js